"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletProvider = WalletProvider;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var solana_headless_core_1 = require("@hermis/solana-headless-core");
var HermisProvider_1 = require("../components/HermisProvider");
var errors_1 = require("@hermis/errors");
var solana_headless_adapter_base_1 = require("@hermis/solana-headless-adapter-base");
var useStandardWalletAdapters_1 = require("../hooks/useStandardWalletAdapters");
var useConnection_1 = require("../hooks/useConnection");
var useLocalStorage_1 = require("../hooks/useLocalStorage");
var useWallet_1 = require("../hooks/useWallet");
var errors_2 = require("../utils/errors");
/**
 * Type guards for wallet adapter capabilities
 */
function supportsSignMessage(adapter) {
    return 'signMessage' in adapter && typeof adapter.signMessage === 'function';
}
function supportsSignTransaction(adapter) {
    return 'signTransaction' in adapter && typeof adapter.signTransaction === 'function';
}
function supportsSignAllTransactions(adapter) {
    return 'signAllTransactions' in adapter && typeof adapter.signAllTransactions === 'function';
}
function supportsSignIn(adapter) {
    return 'signIn' in adapter && typeof adapter.signIn === 'function';
}
/**
 * Provider for Solana wallet functionality
 *
 * This provider manages wallet state, connections, and disconnections.
 * It also persists the selected wallet name in the configured storage.
 *
 * @param props WalletProviderProps
 * @returns WalletProvider component
 */
function WalletProvider(_a) {
    var _this = this;
    var _b;
    var children = _a.children, adapters = _a.wallets, _c = _a.autoConnect, autoConnect = _c === void 0 ? false : _c, _d = _a.storageKey, storageKey = _d === void 0 ? 'walletName' : _d, storageFactory = _a.storageFactory, onError = _a.onError;
    var _e = (0, useConnection_1.useConnection)(), connection = _e.connection, network = _e.network;
    // Safely access rpcEndpoint - only exists on legacy Connection, not Kit Rpc
    var rpcEndpoint = connection && 'rpcEndpoint' in connection ? connection.rpcEndpoint : undefined;
    var adaptersWithStandardAdapters = (0, useStandardWalletAdapters_1.useStandardWalletAdapters)(adapters, rpcEndpoint, (0, HermisProvider_1.toWalletAdapterNetwork)(network));
    var _f = (0, useLocalStorage_1.useLocalStorage)(storageKey, null, storageFactory), walletName = _f[0], setWalletName = _f[1];
    var latestAdapterRef = (0, react_1.useRef)(null);
    var _g = (0, react_1.useState)({
        adapter: null,
        connected: false,
        connecting: false,
        disconnecting: false,
        publicKey: null
    }), adapterState = _g[0], setAdapterState = _g[1];
    // Chain computed from connection for Kit integration
    var currentChain = (0, react_1.useMemo)(function () {
        var network = (0, solana_headless_adapter_base_1.getNetworkFromConnection)(connection);
        return (0, solana_headless_adapter_base_1.getChainId)(network);
    }, [connection]);
    var onErrorRef = (0, react_1.useRef)(onError);
    var isUnloadingRef = (0, react_1.useRef)(false);
    var hasUserSelectedAWallet = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        onErrorRef.current = onError;
        return function () {
            onErrorRef.current = undefined;
        };
    }, [onError]);
    var handleErrorRef = (0, react_1.useRef)(function (error, adapter) {
        if (!isUnloadingRef.current) {
            if (onErrorRef.current) {
                onErrorRef.current(error, adapter);
            }
            else {
                console.error(error, adapter);
                if (error instanceof solana_headless_core_1.WalletNotReadyError && typeof window !== 'undefined' && adapter) {
                    window.open(adapter.url, '_blank');
                }
            }
        }
        return error;
    });
    var findAdapter = (0, react_1.useCallback)(function (name) {
        var _a;
        return name ? (_a = adaptersWithStandardAdapters.find(function (a) { return a.name === name; })) !== null && _a !== void 0 ? _a : null : null;
    }, [adaptersWithStandardAdapters]);
    // Handle adapter selection when wallet name or adapters change
    (0, react_1.useEffect)(function () {
        if (!walletName || !autoConnect)
            return;
        var adapter = findAdapter(walletName);
        // Update adapter reference and state
        latestAdapterRef.current = adapter;
        setAdapterState(function (prev) { return (__assign(__assign({}, prev), { adapter: adapter, connected: (adapter === null || adapter === void 0 ? void 0 : adapter.connected) || false, publicKey: (adapter === null || adapter === void 0 ? void 0 : adapter.publicKey) || null })); });
    }, [walletName, findAdapter, autoConnect, adaptersWithStandardAdapters]);
    var changeWallet = (0, react_1.useCallback)(function (nextWalletName) {
        if (walletName === nextWalletName)
            return;
        var currentAdapter = adapterState.adapter;
        if (currentAdapter &&
            currentAdapter.name !== solana_headless_adapter_base_1.SolanaMobileWalletAdapterWalletName &&
            currentAdapter.connected) {
            currentAdapter.disconnect();
        }
        latestAdapterRef.current = currentAdapter;
        setWalletName(nextWalletName);
    }, [adapterState.adapter, setWalletName, walletName]);
    var updateWalletNameAsync = (0, react_1.useCallback)(function (newValue) { return __awaiter(_this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            hasUserSelectedAWallet.current = true;
            return [2 /*return*/, new Promise(function (resolve) {
                    var selectedAdapter = findAdapter(newValue);
                    latestAdapterRef.current = selectedAdapter;
                    setAdapterState(function (prev) { return (__assign(__assign({}, prev), { adapter: selectedAdapter, connected: (selectedAdapter === null || selectedAdapter === void 0 ? void 0 : selectedAdapter.connected) || false, publicKey: (selectedAdapter === null || selectedAdapter === void 0 ? void 0 : selectedAdapter.publicKey) || null })); });
                    changeWallet(newValue);
                    setTimeout(resolve, 50);
                })];
        });
    }); }, [changeWallet, findAdapter]);
    (0, react_1.useEffect)(function () {
        var currentAdapter = adapterState.adapter;
        if (!currentAdapter)
            return;
        function handleDisconnect() {
            if (isUnloadingRef.current)
                return;
            setWalletName(null);
        }
        currentAdapter.on('disconnect', handleDisconnect);
        return function () {
            currentAdapter.off('disconnect', handleDisconnect);
        };
    }, [adapterState.adapter, setWalletName]);
    var _h = (0, react_1.useState)(function () {
        return adapters
            .map(function (adapter) { return ({
            adapter: adapter,
            readyState: adapter.readyState,
        }); })
            .filter(function (_a) {
            var readyState = _a.readyState;
            return readyState !== solana_headless_core_1.WalletReadyState.Unsupported;
        });
    }), wallets = _h[0], setWallets = _h[1];
    (0, react_1.useEffect)(function () {
        setWallets(function (wallets) {
            return adapters
                .map(function (adapter, index) {
                var wallet = wallets[index];
                return wallet && wallet.adapter === adapter && wallet.readyState === adapter.readyState
                    ? wallet
                    : {
                        adapter: adapter,
                        readyState: adapter.readyState,
                    };
            })
                .filter(function (_a) {
                var readyState = _a.readyState;
                return readyState !== solana_headless_core_1.WalletReadyState.Unsupported;
            });
        });
        function handleReadyStateChange(readyState) {
            var _this = this;
            setWallets(function (prevWallets) {
                var index = prevWallets.findIndex(function (_a) {
                    var adapter = _a.adapter;
                    return adapter === _this;
                });
                if (index === -1)
                    return prevWallets;
                var adapter = prevWallets[index].adapter;
                return __spreadArray(__spreadArray(__spreadArray([], prevWallets.slice(0, index), true), [
                    { adapter: adapter, readyState: readyState }
                ], false), prevWallets.slice(index + 1), true).filter(function (_a) {
                    var readyState = _a.readyState;
                    return readyState !== solana_headless_core_1.WalletReadyState.Unsupported;
                });
            });
        }
        adapters.forEach(function (adapter) { return adapter.on('readyStateChange', handleReadyStateChange, adapter); });
        return function () {
            adapters.forEach(function (adapter) { return adapter.off('readyStateChange', handleReadyStateChange, adapter); });
        };
    }, [adapters]);
    var wallet = (0, react_1.useMemo)(function () { var _a; return (_a = wallets.find(function (wallet) { return wallet.adapter === adapterState.adapter; })) !== null && _a !== void 0 ? _a : null; }, [adapterState.adapter, wallets]);
    // Compute Kit signers from the current adapter
    var kitSigners = (0, react_1.useMemo)(function () {
        var currentAdapter = latestAdapterRef.current || adapterState.adapter;
        return (0, solana_headless_adapter_base_1.createKitSignersFromAdapter)(currentAdapter, connection);
    }, [adapterState.adapter, adapterState.connected, adapterState.publicKey, connection]);
    (0, react_1.useEffect)(function () {
        if (walletName === solana_headless_adapter_base_1.SolanaMobileWalletAdapterWalletName && (0, solana_headless_adapter_base_1.getIsMobile)(adaptersWithStandardAdapters)) {
            isUnloadingRef.current = false;
            return;
        }
        function handleBeforeUnload() {
            isUnloadingRef.current = true;
        }
        window.addEventListener('beforeunload', handleBeforeUnload);
        return function () {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [adaptersWithStandardAdapters, walletName]);
    (0, react_1.useEffect)(function () {
        var currentAdapter = adapterState.adapter;
        if (!currentAdapter)
            return;
        function handleConnect(publicKey) {
            if (isUnloadingRef.current)
                return;
            setAdapterState(function (prev) { return (__assign(__assign({}, prev), { connected: true, connecting: false, disconnecting: false, publicKey: publicKey })); });
        }
        function handleDisconnect() {
            if (isUnloadingRef.current)
                return;
            setAdapterState(function (prev) { return (__assign(__assign({}, prev), { connected: false, connecting: false, disconnecting: false, publicKey: null })); });
        }
        function handleError(error) {
            currentAdapter === null || currentAdapter === void 0 ? void 0 : currentAdapter.emit('disconnect');
            changeWallet(null);
            handleErrorRef.current(error, currentAdapter);
        }
        currentAdapter.on('connect', handleConnect);
        currentAdapter.on('disconnect', handleDisconnect);
        currentAdapter.on('error', handleError);
        if (currentAdapter.connected && currentAdapter.publicKey) {
            handleConnect(currentAdapter.publicKey);
        }
        return function () {
            currentAdapter.off('connect', handleConnect);
            currentAdapter.off('disconnect', handleDisconnect);
            currentAdapter.off('error', handleError);
        };
    }, [adapterState.adapter]);
    var handleAutoConnectRequest = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var currentAdapter, shouldAutoConnect, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentAdapter = adapterState.adapter;
                    if (!autoConnect || !currentAdapter)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 8, , 9]);
                    if (!(typeof autoConnect === 'function')) return [3 /*break*/, 3];
                    return [4 /*yield*/, autoConnect(currentAdapter)];
                case 2:
                    shouldAutoConnect = _a.sent();
                    if (!shouldAutoConnect)
                        return [2 /*return*/];
                    _a.label = 3;
                case 3:
                    setAdapterState(function (prev) { return (__assign(__assign({}, prev), { connecting: true })); });
                    // Set RPC endpoint for cluster detection if adapter supports it
                    if (rpcEndpoint && 'setRpcEndpoint' in currentAdapter && typeof currentAdapter.setRpcEndpoint === 'function') {
                        currentAdapter.setRpcEndpoint(rpcEndpoint);
                    }
                    if (!hasUserSelectedAWallet.current) return [3 /*break*/, 5];
                    return [4 /*yield*/, currentAdapter.connect()];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, currentAdapter.autoConnect()];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    error_1 = _a.sent();
                    console.error('Auto-connect error:', error_1);
                    setAdapterState(function (prev) { return (__assign(__assign({}, prev), { connecting: false })); });
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); }, [autoConnect, adapterState.adapter]);
    (0, react_1.useEffect)(function () {
        if (adapterState.adapter) {
            handleAutoConnectRequest();
        }
        return function () {
            // Patch fix, This needs to be address 
            // in the @solana-mobile/wallet-adapter-mobile package
            if (adapterState.connecting) {
                setWalletName(null);
            }
        };
    }, [handleAutoConnectRequest, adapterState.adapter]);
    var handleConnect = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var currentAdapter, error_2;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentAdapter = latestAdapterRef.current || adapterState.adapter;
                    if (!currentAdapter)
                        throw new errors_2.WalletNotSelectedError();
                    setAdapterState(function (prev) { return (__assign(__assign({}, prev), { connecting: true })); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 2, , 4]);
                    return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                            var isConnected_1, publicKey_1, error_3;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 4]);
                                        // Set RPC endpoint for cluster detection if adapter supports it
                                        if (rpcEndpoint && 'setRpcEndpoint' in currentAdapter && typeof currentAdapter.setRpcEndpoint === 'function') {
                                            currentAdapter.setRpcEndpoint(rpcEndpoint);
                                        }
                                        return [4 /*yield*/, currentAdapter.connect()];
                                    case 1:
                                        _a.sent();
                                        isConnected_1 = currentAdapter.connected;
                                        publicKey_1 = currentAdapter.publicKey;
                                        setAdapterState(function (prev) { return (__assign(__assign({}, prev), { adapter: currentAdapter, connected: isConnected_1, connecting: false, publicKey: publicKey_1 })); });
                                        latestAdapterRef.current = currentAdapter;
                                        setTimeout(function () { return resolve(currentAdapter); }, 50);
                                        return [3 /*break*/, 4];
                                    case 2:
                                        error_3 = _a.sent();
                                        reject();
                                        return [4 /*yield*/, handleDisconnect()];
                                    case 3:
                                        _a.sent();
                                        throw error_3;
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); })];
                case 2:
                    error_2 = _a.sent();
                    handleErrorRef.current(error_2, currentAdapter);
                    setAdapterState(function (prev) { return (__assign(__assign({}, prev), { connecting: false })); });
                    return [4 /*yield*/, handleDisconnect()];
                case 3:
                    _a.sent();
                    throw error_2;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [adapterState.adapter]);
    var handleDisconnect = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var currentAdapter, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentAdapter = latestAdapterRef.current || adapterState.adapter;
                    if (!currentAdapter)
                        return [2 /*return*/];
                    setAdapterState(function (prev) { return (__assign(__assign({}, prev), { connected: false, adapter: null, publicKey: null, connecting: false, disconnecting: true })); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, currentAdapter.disconnect()];
                case 2:
                    _a.sent();
                    changeWallet(null);
                    setWalletName(null);
                    return [3 /*break*/, 5];
                case 3:
                    error_4 = _a.sent();
                    handleErrorRef.current(error_4, currentAdapter);
                    return [3 /*break*/, 5];
                case 4:
                    setAdapterState(function (prev) { return (__assign(__assign({}, prev), { disconnecting: false })); });
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [adapterState.adapter]);
    var handleSignAndSendTransaction = (0, react_1.useCallback)(function (transaction, connection, options) { return __awaiter(_this, void 0, void 0, function () {
        var currentAdapter, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentAdapter = latestAdapterRef.current || adapterState.adapter;
                    if (!currentAdapter)
                        throw new errors_2.WalletNotSelectedError();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!currentAdapter.signAndSendTransaction) return [3 /*break*/, 3];
                    return [4 /*yield*/, currentAdapter.signAndSendTransaction(transaction, connection, options)];
                case 2: return [2 /*return*/, _a.sent()];
                case 3: return [4 /*yield*/, currentAdapter.sendTransaction(transaction, connection, options)];
                case 4: return [2 /*return*/, _a.sent()];
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_5 = _a.sent();
                    handleErrorRef.current(error_5, currentAdapter);
                    throw error_5;
                case 7: return [2 /*return*/];
            }
        });
    }); }, [adapterState.adapter]);
    var handleSendTransaction = (0, react_1.useCallback)(function (transaction, connection, options) { return __awaiter(_this, void 0, void 0, function () {
        var currentAdapter, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentAdapter = latestAdapterRef.current || adapterState.adapter;
                    if (!currentAdapter)
                        throw new errors_2.WalletNotSelectedError();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, currentAdapter.sendTransaction(transaction, connection, options)];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_6 = _a.sent();
                    handleErrorRef.current(error_6, currentAdapter);
                    throw error_6;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [adapterState.adapter]);
    var handleSignTransaction = (0, react_1.useCallback)(function (transaction) { return __awaiter(_this, void 0, Promise, function () {
        var currentAdapter, error_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentAdapter = latestAdapterRef.current || adapterState.adapter;
                    if (!currentAdapter)
                        throw new errors_2.WalletNotSelectedError();
                    if (!supportsSignTransaction(currentAdapter)) {
                        throw new errors_1.HermisError(errors_1.HERMIS_ERROR__STANDARD_WALLET__FEATURE_NOT_FOUND, { featureName: 'signTransaction', walletName: currentAdapter.name || 'Unknown wallet' });
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, solana_headless_core_1.signTransaction)(transaction, currentAdapter)];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_7 = _a.sent();
                    handleErrorRef.current(error_7, currentAdapter);
                    throw error_7;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [adapterState.adapter]);
    var handleSignAllTransactions = (0, react_1.useCallback)(function (transactions) { return __awaiter(_this, void 0, Promise, function () {
        var currentAdapter, error_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentAdapter = latestAdapterRef.current || adapterState.adapter;
                    if (!currentAdapter)
                        throw new errors_2.WalletNotSelectedError();
                    if (!supportsSignAllTransactions(currentAdapter)) {
                        throw new errors_1.HermisError(errors_1.HERMIS_ERROR__STANDARD_WALLET__FEATURE_NOT_FOUND, { featureName: 'signAllTransactions', walletName: currentAdapter.name || 'Unknown wallet' });
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, solana_headless_core_1.signAllTransactions)(transactions, currentAdapter)];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_8 = _a.sent();
                    handleErrorRef.current(error_8, currentAdapter);
                    throw error_8;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [adapterState.adapter]);
    var handleSignMessage = (0, react_1.useCallback)(function (message) { return __awaiter(_this, void 0, void 0, function () {
        var currentAdapter, error_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentAdapter = latestAdapterRef.current || adapterState.adapter;
                    if (!currentAdapter)
                        throw new errors_2.WalletNotSelectedError();
                    if (!supportsSignMessage(currentAdapter)) {
                        throw new errors_1.HermisError(errors_1.HERMIS_ERROR__STANDARD_WALLET__FEATURE_NOT_FOUND, { featureName: 'signMessage', walletName: currentAdapter.name || 'Unknown wallet' });
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, solana_headless_core_1.signMessage)(message, currentAdapter)];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_9 = _a.sent();
                    handleErrorRef.current(error_9, currentAdapter);
                    throw error_9;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [adapterState.adapter]);
    var handleSignIn = (0, react_1.useCallback)(function (input) { return __awaiter(_this, void 0, void 0, function () {
        var currentAdapter, error_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentAdapter = latestAdapterRef.current || adapterState.adapter;
                    if (!currentAdapter)
                        throw new errors_2.WalletNotSelectedError();
                    if (!supportsSignIn(currentAdapter)) {
                        throw new errors_1.HermisError(errors_1.HERMIS_ERROR__STANDARD_WALLET__FEATURE_NOT_FOUND, { featureName: 'signIn', walletName: currentAdapter.name || 'Unknown wallet' });
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, solana_headless_core_1.signIn)(currentAdapter, input)];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_10 = _a.sent();
                    handleErrorRef.current(error_10, currentAdapter);
                    throw error_10;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [adapterState.adapter]);
    var hasFeature = (0, react_1.useCallback)(function (feature) {
        var currentAdapter = latestAdapterRef.current || adapterState.adapter;
        if (!currentAdapter)
            return false;
        return feature in currentAdapter;
    }, [adapterState.adapter]);
    // Helper to get chain ID for a network
    var handleGetChainId = (0, react_1.useCallback)(function (network) {
        return (0, solana_headless_adapter_base_1.getChainId)(network);
    }, []);
    // EXTENDED METHODS: These now support BOTH web3.js and Kit architectures automatically
    // No more "DualArchitecture" or "Unified" suffixes - just the standard names!
    var handleSignTransactionExtended = (0, react_1.useCallback)(function (transaction, options) { return __awaiter(_this, void 0, Promise, function () {
        var currentAdapter, signTransactionCore, error_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentAdapter = latestAdapterRef.current || adapterState.adapter;
                    if (!currentAdapter)
                        throw new errors_2.WalletNotSelectedError();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, Promise.resolve().then(function () { return require('@hermis/solana-headless-core'); })];
                case 2:
                    signTransactionCore = (_a.sent()).signTransaction;
                    return [4 /*yield*/, signTransactionCore(transaction, currentAdapter, options)];
                case 3: 
                // Route to core - it automatically detects web3.js vs Kit
                // return await currentAdapter.signTransaction(transaction as any, currentAdapter, options) as T;
                return [2 /*return*/, _a.sent()];
                case 4:
                    error_11 = _a.sent();
                    handleErrorRef.current(error_11, currentAdapter);
                    throw error_11;
                case 5: return [2 /*return*/];
            }
        });
    }); }, [adapterState.adapter]);
    var handleSendTransactionExtended = (0, react_1.useCallback)(function (transaction, connection, options) { return __awaiter(_this, void 0, Promise, function () {
        var currentAdapter, error_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentAdapter = latestAdapterRef.current || adapterState.adapter;
                    if (!currentAdapter)
                        throw new errors_2.WalletNotSelectedError();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, currentAdapter.sendTransaction(transaction, connection, options)];
                case 2: 
                // Call adapter's sendTransaction directly - it has signature detection logic
                // This ensures signed transactions are sent without prompting the wallet again
                return [2 /*return*/, _a.sent()];
                case 3:
                    error_12 = _a.sent();
                    handleErrorRef.current(error_12, currentAdapter);
                    throw error_12;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [adapterState.adapter]);
    var handleSignAndSendTransactionExtended = (0, react_1.useCallback)(function (transaction, connection, options) { return __awaiter(_this, void 0, Promise, function () {
        var currentAdapter, signAndSendTransactionCore, error_13;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentAdapter = latestAdapterRef.current || adapterState.adapter;
                    if (!currentAdapter)
                        throw new errors_2.WalletNotSelectedError();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, Promise.resolve().then(function () { return require('@hermis/solana-headless-core'); })];
                case 2:
                    signAndSendTransactionCore = (_a.sent()).signAndSendTransaction;
                    return [4 /*yield*/, signAndSendTransactionCore(connection, transaction, currentAdapter, options)];
                case 3: 
                // Route to core - it automatically detects web3.js vs Kit
                return [2 /*return*/, _a.sent()];
                case 4:
                    error_13 = _a.sent();
                    handleErrorRef.current(error_13, currentAdapter);
                    throw error_13;
                case 5: return [2 /*return*/];
            }
        });
    }); }, [adapterState.adapter]);
    var handleSignAllTransactionsExtended = (0, react_1.useCallback)(function (transactions, options) { return __awaiter(_this, void 0, Promise, function () {
        var currentAdapter, signAllTransactionsCore, error_14;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentAdapter = latestAdapterRef.current || adapterState.adapter;
                    if (!currentAdapter)
                        throw new errors_2.WalletNotSelectedError();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, Promise.resolve().then(function () { return require('@hermis/solana-headless-core'); })];
                case 2:
                    signAllTransactionsCore = (_a.sent()).signAllTransactions;
                    return [4 /*yield*/, signAllTransactionsCore(transactions, currentAdapter, options)];
                case 3: 
                // Route to core - it automatically detects web3.js vs Kit
                return [2 /*return*/, _a.sent()];
                case 4:
                    error_14 = _a.sent();
                    handleErrorRef.current(error_14, currentAdapter);
                    throw error_14;
                case 5: return [2 /*return*/];
            }
        });
    }); }, [adapterState.adapter]);
    // Resolve the public key once per render from the most reliable source.
    // Reading refs during render is fine for derivation — they're stable for the
    // life of this render and the memo below only re-runs when the actual fields
    // changed.
    var publicKey = (wallet === null || wallet === void 0 ? void 0 : wallet.adapter.publicKey) ||
        ((_b = adapterState.adapter) === null || _b === void 0 ? void 0 : _b.publicKey) ||
        adapterState.publicKey ||
        null;
    var contextValue = (0, react_1.useMemo)(function () { return ({
        autoConnect: !!autoConnect,
        wallets: wallets,
        wallet: wallet,
        publicKey: publicKey,
        connecting: adapterState.connecting,
        connected: adapterState.connected,
        disconnecting: adapterState.disconnecting,
        // Kit-friendly properties
        address: kitSigners.address,
        addressString: kitSigners.addressString,
        chain: currentChain,
        messageSigner: kitSigners.messageSigner,
        transactionSigner: kitSigners.transactionSigner,
        getChainId: handleGetChainId,
        select: updateWalletNameAsync,
        connect: handleConnect,
        disconnect: handleDisconnect,
        signTransaction: handleSignTransactionExtended,
        sendTransaction: handleSendTransactionExtended,
        signAndSendTransaction: handleSignAndSendTransactionExtended,
        signAllTransactions: handleSignAllTransactionsExtended,
        signMessage: handleSignMessage,
        signIn: handleSignIn,
        hasFeature: hasFeature,
    }); }, [
        autoConnect,
        wallets,
        wallet,
        publicKey,
        adapterState.connecting,
        adapterState.connected,
        adapterState.disconnecting,
        kitSigners,
        currentChain,
        handleGetChainId,
        updateWalletNameAsync,
        handleConnect,
        handleDisconnect,
        handleSignTransactionExtended,
        handleSendTransactionExtended,
        handleSignAndSendTransactionExtended,
        handleSignAllTransactionsExtended,
        handleSignMessage,
        handleSignIn,
        hasFeature,
    ]);
    return ((0, jsx_runtime_1.jsx)(useWallet_1.WalletContext.Provider, { value: contextValue, children: children }));
}
